import { AssetsPage } from './AssetsPage';

export function SalesMarketingPage() {
  return (
    <AssetsPage
      page="sales_marketing"
      title="Sales & Marketing"
      description="Access sales collateral, marketing materials, and promotional resources"
    />
  );
}
